import serverApi from '../../utils/serverApi';

const configsService = {
    getList: (data) => serverApi({ uri: 'admin/referrals', method: 'GET', data}),

    create: () => serverApi({ uri: 'admin/referrals', method: 'POST' }),
};

export default configsService;
